import {Form, Modal, Input, TextArea, Button, Popconfirm, Select, message} from "antd";
import {useFormik} from "formik";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import stores from "../../../store/stores";

const PermissionPolicyModal = ({
    visibility,
    modalTitle,
    detail,
    onCancel,
    setRecallPermissionPolicy
}) => {
    const [sendLoading, setSendLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const {TextArea} = Input;
    const {t} = useTranslation(["userAuthorization"]);
    const onOk = async () => {
        handleSubmit();
    };

    const isDetail =
        modalTitle === t("modals.permissionPolicyDetailModal.label", {ns: "userAuthorization"});
    const formik = useFormik({
        initialValues: {
            nameTr: detail?.name.tr,
            nameEn: detail?.name.en,
            key: detail?.key,
            descriptionTr: detail?.description.tr,
            descriptionEn: detail?.description.en,
            tags: detail?.tags
        },

        enableReinitialize: true,
        onSubmit: async () => {
            setSendLoading(true);
            if (!isDetail) {
                const {nameTr, nameEn, key, descriptionTr, descriptionEn, tags} = values;

                if (
                    !nameTr ||
                    !nameEn ||
                    !key ||
                    !descriptionTr ||
                    !descriptionEn ||
                    !tags.length
                ) {
                    setSendLoading(false);
                    message.error(t("common.pleaseFillAllFields", {ns: "userAuthorization"}));
                    return;
                }
                await stores.authorizationStore.createPermissionPolicy({
                    key: values.key,
                    name: {
                        tr: values.nameTr,
                        en: values.nameEn
                    },
                    description: {
                        tr: values.descriptionTr,
                        en: values.descriptionEn
                    },
                    tags: values.tags
                });
            } else {
                await stores.authorizationStore.updatePermissionPolicy({
                    permissionPolicyId: detail._id,
                    key: values.key,
                    name: {
                        tr: values.nameTr,
                        en: values.nameEn
                    },
                    description: {
                        tr: values.descriptionTr,
                        en: values.descriptionEn
                    },
                    tags: values.tags
                });
            }
            setRecallPermissionPolicy(prev => !prev);
            onCancel();
            setSendLoading(false);
        }
    });
    const {values, setFieldValue, handleSubmit} = formik;

    const deletePermissionPolicy = async () => {
        setDeleteLoading(true);
        await stores.authorizationStore.deletePermissionPolicy({
            permissionPolicyId: detail._id
        });

        setRecallPermissionPolicy(prev => !prev);
        onCancel();
        setDeleteLoading(false);
    };

    const renderFooter = () => {
        return (
            <>
                <Popconfirm
                    title={t("confirms.permissionPolicy.delete.title", {ns: "userAuthorization"})}
                    description={t("confirms.permissionPolicy.delete.description", {
                        ns: "userAuthorization"
                    })}
                    onConfirm={deletePermissionPolicy}
                    okText={t("modal.yesButton", {ns: "common"})}
                    cancelText={t("modal.noButton", {ns: "common"})}
                >
                    <Button
                        style={{
                            float: "left"
                        }}
                        type="primary"
                        danger
                        disabled={deleteLoading}
                        loading={deleteLoading}
                    >
                        {t("actions.delete", {ns: "common"})}
                    </Button>
                </Popconfirm>

                <Button onClick={onCancel}>{t("modal.cancelButton", {ns: "common"})}</Button>

                <Button type="primary" disabled={sendLoading} loading={sendLoading} onClick={onOk}>
                    {isDetail ? t("actions.update", {ns: "common"}) : t("modal.saveButton", {ns: "common"})}
                </Button>
            </>
        );
    };

    const handleChange = value => {
        setFieldValue("tags", value);
    };
    return (
        <Modal
            centered
            width={800}
            title={modalTitle}
            visible={visibility}
            onCancel={onCancel}
            footer={renderFooter()}
        >
            <Form layout={"vertical"} style={{maxWidth: 600}}>
                <Form.Item label={t("common.permissionPolicy") + " tr"}>
                    <Input
                        value={values?.nameTr}
                        onChange={e => {
                            setFieldValue("nameTr", e.target.value);
                        }}
                    />
                </Form.Item>
                <Form.Item label={t("common.permissionPolicy") + " en"}>
                    <Input
                        value={values?.nameEn}
                        onChange={e => {
                            setFieldValue("nameEn", e.target.value);
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={t("components.permissionPolicyList.fields.tags", {
                        ns: "userAuthorization"
                    })}
                >
                    <Select
                        mode="tags"
                        allowClear
                        style={{
                            width: "100%"
                        }}
                        placeholder={t("common.selectPermissionPolicy", {
                            ns: "userAuthorization"
                        })}
                        value={values?.tags}
                        onChange={handleChange}
                    />
                </Form.Item>
                <Form.Item
                    label={t("components.permissionPolicyList.fields.key", {
                        ns: "userAuthorization"
                    })}
                >
                    <Input
                        value={values?.key}
                        onChange={e => {
                            setFieldValue("key", e.target.value);
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={
                        t("components.permissionPolicyList.fields.description", {
                            ns: "userAuthorization"
                        }) + " tr"
                    }
                >
                    <TextArea
                        value={values?.descriptionTr}
                        onChange={e => {
                            setFieldValue("descriptionTr", e.target.value);
                        }}
                        rows={4}
                    />
                </Form.Item>
                <Form.Item
                    label={
                        t("components.permissionPolicyList.fields.description", {
                            ns: "userAuthorization"
                        }) + " en"
                    }
                >
                    <TextArea
                        value={values?.descriptionEn}
                        onChange={e => {
                            setFieldValue("descriptionEn", e.target.value);
                        }}
                        rows={4}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PermissionPolicyModal;
